import styled, { css } from 'styled-components';
import { Color } from '../../base';

const SectionWrapper = styled.div`
  border-bottom: 2px solid ${Color.grey};
  width: 100%;
  display: block;
  transition: all ease-in-out 0.2s;

  &:last-child {
    margin-bottom: 0;
    border-bottom: 0;
  }

  ${props =>
    props.small
      ? css`
          margin-bottom: 5px;
          padding: 5px 0;
        `
      : css`
          margin-bottom: 10px;
          padding: 10px 0;
        `}
`;

export { SectionWrapper };
